import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [{
  path: '/',
  name: 'Home',
  redirect: '/home',
  component: () => import( /* webpackChunkName: "home" */ '../views/home/index.vue'),
  children: [{
    path: '/home',
    name: 'home',
    component: () => import( /* webpackChunkName: "home" */ '../views/home/home.vue'),
  },
  {
    path: '/classCourse',
    name: 'classCourse',
    redirect: '/classCourse/chapters',
    component: () => import( /* webpackChunkName: "classCourse" */ '../views/classCourse/index.vue'),
    children: [
      {
        path: '/classCourse/chapters',
        name: 'chapters',
        component: () => import( /* webpackChunkName: "chapters" */ '../views/classCourse/chapters.vue'),
      },
      {
        path: '/classCourse/teams',
        name: 'teams',
        component: () => import( /* webpackChunkName: "teams" */ '../views/classCourse/teams.vue'),
      },
      {
        path: '/classCourse/teams/teamDetail',
        name: 'teamDetail',
        component: () => import( /* webpackChunkName: "teamDetail" */ '../views/classCourse/teamDetail.vue'),
      },
      {
        path: '/classCourse/students',
        name: 'students',
        component: () => import( /* webpackChunkName: "students" */ '../views/classCourse/students.vue'),
      },
      {
        path: '/classCourse/rank',
        name: 'rank',
        component: () => import( /* webpackChunkName: "rank" */ '../views/classCourse/rank.vue'),
      },
      {
        path: '/classCourse/platformaccount',
        name: 'platformAccount',
        component: () => import( /* webpackChunkName: "platformAccount" */ '../views/classCourse/platformAccount.vue'),
      },
      {
        path: '/classCourse/works',
        name: 'works',
        component: () => import( /* webpackChunkName: "works" */ '../views/classCourse/works.vue'),
      },
      {
        path: '/classCourse/questionBank',
        name: 'questionBank',
        component: () => import( /* webpackChunkName: "questionBank" */ '../views/classCourse/questionBank/index.vue'),
      },
      {
        path: '/classCourse/questionBank/detail',
        name: 'questionDetail',
        component: () => import( /* webpackChunkName: "questionDetail" */ '../views/classCourse/questionBank/detail.vue'),
      },
      {
        path: '/classCourse/exam',
        name: 'exam',
        component: () => import( /* webpackChunkName: "exam" */ '../views/classCourse/exam/index.vue'),
      },
      {
        path: '/classCourse/exam/detail',
        name: 'examDetail',
        component: () => import( /* webpackChunkName: "examDetail" */ '../views/classCourse/exam/detail.vue'),
      },
      {
        path: '/classCourse/exam/autoSetExam',
        name: 'autoSetExam',
        component: () => import( /* webpackChunkName: "autoSetExam" */ '../views/classCourse/exam/autoSetExam.vue'),
      },
      {
        path: '/classCourse/exam/setExam',
        name: 'setExam',
        component: () => import( /* webpackChunkName: "setExam" */ '../views/classCourse/exam/setExam.vue'),
      },
      {
        path: '/classCourse/exam/examBank',
        name: 'examBank',
        component: () => import( /* webpackChunkName: "examBank" */ '../views/classCourse/exam/examBank.vue'),
      },
      {
        path: '/classCourse/exam/settings',
        name: 'settings',
        component: () => import( /* webpackChunkName: "settings" */ '../views/classCourse/exam/settings.vue'),
      },
      {
        path: '/classCourse/exam/review',
        name: 'review',
        component: () => import( /* webpackChunkName: "review" */ '../views/classCourse/exam/review/index.vue'),
      },
      {
        path: '/classCourse/evaluation',
        name: 'evaluation',
        component: () => import( /* webpackChunkName: "evaluation" */ '../views/classCourse/evaluation/index.vue'),
      },
      {
        path: '/classCourse/evaluation/knowledge',
        name: 'knowledge',
        component: () => import( /* webpackChunkName: "knowledge" */ '../views/classCourse/evaluation/knowledge/index.vue'),
      },
      {
        path: '/classCourse/evaluation/knowledge/situation',
        name: 'situation',
        component: () => import( /* webpackChunkName: "situation" */ '../views/classCourse/evaluation/knowledge/situation.vue'),
      },
      {
        path: '/classCourse/evaluation/attitude',
        name: 'attitude',
        component: () => import( /* webpackChunkName: "attitude" */ '../views/classCourse/evaluation/attitude/index.vue'),
      },
      {
        path: '/classCourse/evaluation/attitude/detail',
        name: 'attitudeDetail',
        component: () => import( /* webpackChunkName: "attitudeDetail" */ '../views/classCourse/evaluation/attitude/attitudeDetail.vue'),
      },
      {
        path: '/classCourse/evaluation/skill',
        name: 'skill',
        component: () => import( /* webpackChunkName: "skill" */ '../views/classCourse/evaluation/skill/index.vue'),
      },
      {
        path: '/classCourse/evaluation/skill/detail',
        name: 'skillDetail',
        component: () => import( /* webpackChunkName: "skillDetail" */ '../views/classCourse/evaluation/skill/skillDetail.vue'),
      },
      {
        path: '/classCourse/evaluation/attainment',
        name: 'attainment',
        component: () => import( /* webpackChunkName: "attainment" */ '../views/classCourse/evaluation/attainment/index.vue'),
      },
      {
        path: '/classCourse/evaluation/attainment/detail',
        name: 'attainmentDetail',
        component: () => import( /* webpackChunkName: "attainmentDetail" */ '../views/classCourse/evaluation/attainment/attainmentDetail.vue'),
      },
      {
        path: '/classCourse/evaluation/finalExam',
        name: 'finalExam',
        component: () => import( /* webpackChunkName: "finalExam" */ '../views/classCourse/evaluation/finalExam.vue'),
      },
      {
        path: '/classCourse/evaluation/teacherEvaluation',
        name: 'teacherEvaluation',
        component: () => import( /* webpackChunkName: "teacherEvaluation" */ '../views/classCourse/evaluation/teacherEvaluation.vue'),
      },
      {
        path: '/classCourse/projectPractice',
        name: 'projectPractice',
        component: () => import( /* webpackChunkName: "projectPractice" */ '../views/classCourse/projectPractice'),
      },
      {
        path: '/classCourse/projectPractice/buildTeam',
        name: 'buildTeam',
        component: () => import( /* webpackChunkName: "buildTeam" */ '../views/classCourse/projectPractice/buildTeam'),
      },
      {
        path: '/classCourse/projectPractice/accountLocation',
        name: 'accountLocation',
        component: () => import( /* webpackChunkName: "accountLocation" */ '../views/classCourse/projectPractice/accountLocation'),
      },
      {
        path: '/classCourse/projectPractice/accountEstablish',
        name: 'accountEstablish',
        component: () => import( /* webpackChunkName: "accountEstablish" */ '../views/classCourse/projectPractice/accountEstablish'),
      },
      {
        path: '/classCourse/projectPractice/copywriting',
        name: 'copywriting',
        component: () => import( /* webpackChunkName: "copywriting" */ '../views/classCourse/projectPractice/copywriting'),
      },
      {
        path: '/classCourse/projectPractice/scenario',
        name: 'scenario',
        component: () => import( /* webpackChunkName: "scenario" */ '../views/classCourse/projectPractice/scenario'),
      },
      {
        path: '/classCourse/projectPractice/videoShooting',
        name: 'videoShooting',
        component: () => import( /* webpackChunkName: "videoShooting" */ '../views/classCourse/projectPractice/videoShooting'),
      },
      {
        path: '/classCourse/projectPractice/videoClip',
        name: 'videoClip',
        component: () => import( /* webpackChunkName: "videoClip" */ '../views/classCourse/projectPractice/videoClip'),
      },
      {
        path: '/classCourse/projectPractice/accountOperation',
        name: 'accountOperation',
        component: () => import( /* webpackChunkName: "accountOperation" */ '../views/classCourse/projectPractice/accountOperation'),
      },
      {
        path: '/classCourse/projectPractice/roadshow',
        name: 'roadshow',
        component: () => import( /* webpackChunkName: "roadshow" */ '../views/classCourse/projectPractice/roadshow'),
      },
      {
        path: '/classCourse/projectPractice/analysis',
        name: 'analysis',
        component: () => import( /* webpackChunkName: "analysis" */ '../views/classCourse/projectPractice/analysis'),
      },
    ]
  },  
  {
    path: '/classSettings',
    name: 'classSettings',
    component: () => import( /* webpackChunkName: "classSettings" */ '../views/classSettings/index.vue'),
  },
  {
    path: '/securityQuestion',
    name: 'securityQuestion',
    component: () => import( /* webpackChunkName: "securityQuestion" */ '../views/securityQuestion/index.vue'),
  },
  {
    path: '/helpCenter',
    name: 'helpCenter',
    component: () => import( /* webpackChunkName: "helpCenter" */ '../views/helpCenter/index.vue'),
  },
  {
    path: '/message',
    name: 'message',
    component: () => import( /* webpackChunkName: "message" */ '../views/message/index.vue'),
  }]
},
{
  path: '/courseDetail',
  name: 'courseDetail',
  redirect: '/courseDetail/video',
  component: () => import( /* webpackChunkName: "courseDetail" */ '../views/courseDetail/index.vue'),
  children: [
    {
      path: '/courseDetail/video',
      name: 'video',
      component: () => import( /* webpackChunkName: "video" */ '../views/courseDetail/video.vue'),
    },
    {
      path: '/courseDetail/courseware',
      name: 'courseware',
      component: () => import( /* webpackChunkName: "courseware" */ '../views/courseDetail/courseware.vue'),
    },
    {
      path: '/courseDetail/testing',
      name: 'testing',
      component: () => import( /* webpackChunkName: "testing" */ '../views/courseDetail/testing.vue'),
    },
    {
      path: '/courseDetail/data',
      name: 'data',
      component: () => import( /* webpackChunkName: "data" */ '../views/courseDetail/data.vue'),
    },
    {
      path: '/courseDetail/practice',
      name: 'practice',
      component: () => import( /* webpackChunkName: "practice" */ '../views/courseDetail/practice/index.vue'),
    },
    {
      path: '/courseDetail/practice/practiceBank',
      name: 'practiceBank',
      component: () => import( /* webpackChunkName: "practiceBank" */ '../views/courseDetail/practice/practiceBank.vue'),
    },
    {
      path: '/courseDetail/practice/pdf',
      name: 'practicePdf',
      component: () => import( /* webpackChunkName: "practicePdf" */ '../views/courseDetail/practice/pdfDetail.vue'),
    },
    {
      path: '/courseDetail/practice/detail',
      name: 'practiceDetail',
      component: () => import( /* webpackChunkName: "practiceDetail" */ '../views/courseDetail/practice/detail.vue'),
    },
    {
      path: '/courseDetail/statistics',
      name: 'statistics',
      component: () => import( /* webpackChunkName: "statistics" */ '../views/courseDetail/statistics/index.vue'),
    },
    {
      path: '/courseDetail/statistics/detail',
      name: 'statisticsDetail',
      component: () => import( /* webpackChunkName: "statisticsDetail" */ '../views/courseDetail/statistics/detail.vue'),
    },
    {
      path: '/courseDetail/activity',
      name: 'activity',
      component: () => import( /* webpackChunkName: "activity" */ '../views/courseDetail/activity/index.vue'),
    },
    {
      path: '/courseDetail/activity/sign',
      name: 'sign',
      component: () => import( /* webpackChunkName: "sign" */ '../views/courseDetail/activity/signin/index.vue'),
    },
    {
      path: '/courseDetail/activity/sign/detail',
      name: 'signDetail',
      component: () => import( /* webpackChunkName: "detail" */ '../views/courseDetail/activity/signin/detail.vue'),
    },
    {
      path: '/courseDetail/activity/vote',
      name: 'vote',
      component: () => import( /* webpackChunkName: "vote" */ '../views/courseDetail/activity/vote/index.vue'),
    },
    {
      path: '/courseDetail/activity/vote/detail',
      name: 'voteDetail',
      component: () => import( /* webpackChunkName: "detail" */ '../views/courseDetail/activity/vote/detail.vue'),
    },
    {
      path: '/courseDetail/activity/pick',
      name: 'pick',
      component: () => import( /* webpackChunkName: "pick" */ '../views/courseDetail/activity/select/index.vue'),
    },
    {
      path: '/courseDetail/activity/pick/detail',
      name: 'pickDetail',
      component: () => import( /* webpackChunkName: "detail" */ '../views/courseDetail/activity/select/detail.vue'),
    },
    {
      path: '/courseDetail/activity/answer',
      name: 'answer',
      component: () => import( /* webpackChunkName: "answer" */ '../views/courseDetail/activity/question/index.vue'),
    },
    {
      path: '/courseDetail/activity/answer/detail',
      name: 'answerDetail',
      component: () => import( /* webpackChunkName: "detail" */ '../views/courseDetail/activity/question/detail.vue'),
    },
    {
      path: '/courseDetail/activity/discuss',
      name: 'discuss',
      component: () => import( /* webpackChunkName: "discuss" */ '../views/courseDetail/activity/discuss/index.vue'),
    },
    {
      path: '/courseDetail/activity/discuss/detail',
      name: 'discussDetail',
      component: () => import( /* webpackChunkName: "detail" */ '../views/courseDetail/activity/discuss/detail.vue'),
    },
    {
      path: '/courseDetail/activity/quiz',
      name: 'quiz',
      component: () => import( /* webpackChunkName: "quiz" */ '../views/courseDetail/activity/quiz/index.vue'),
    },
    {
      path: '/courseDetail/activity/quiz/detail',
      name: 'quizDetail',
      component: () => import( /* webpackChunkName: "detail" */ '../views/courseDetail/activity/quiz/detail.vue'),
    },
    {
      path: '/courseDetail/activity/score',
      name: 'score',
      component: () => import( /* webpackChunkName: "score" */ '../views/courseDetail/activity/score/index.vue'),
    },
    {
      path: '/courseDetail/activity/score/detail',
      name: 'scoreDetail',
      component: () => import( /* webpackChunkName: "detail" */ '../views/courseDetail/activity/score/detail.vue'),
    },
    {
      path: '/courseDetail/works',
      name: 'works',
      component: () => import( /* webpackChunkName: "works" */ '../views/courseDetail/works.vue'),
    },
    {
      path: '/courseDetail/python',
      name: 'python',
      component: () => import( /* webpackChunkName: "python" */ '../views/courseDetail/python.vue'),
    },
    {
      path: '/courseDetail/appraise',
      name: 'appraise',
      component: () => import( /* webpackChunkName: "appraise" */ '../views/courseDetail/appraise/index.vue'),
    },
    {
      path: '/courseDetail/appraise/detail',
      name: 'appraiseDetail',
      component: () => import( /* webpackChunkName: "appraiseDetail" */ '../views/courseDetail/appraise/detail.vue'),
    },
  ]
},
{
  path: '/classCourse/exam/review/detail',
  name: 'reviewDetail',
  component: () => import( /* webpackChunkName: "reviewDetail" */ '../views/classCourse/exam/review/detail.vue'),
},
{
  path: '/login',
  name: 'login',
  component: () => import( /* webpackChunkName: "login" */ '../views/login/index.vue'),
},
{
  path: '/register',
  name: 'register',
  component: () => import( /* webpackChunkName: "register" */ '../views/register/index.vue'),
}
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

export default router